import React, { CSSProperties, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { cleanChatRoom, addMessage } from 'redux/chat/actions';
import socket from 'domain/services/socketIoTemp';
import { updateUserStatus, updateInitialActiveUsers } from 'redux/chat/active_status.slices';
import { getUser } from 'redux/authentication/auth.slice';
import { updateUnreadMessageCount } from 'redux/chat/group_messages.slices';
import { updateUnreadDirrectMessageCount } from 'redux/chat/direct_messages.slices';
import { getCurrentScreenView } from 'redux/mobile_screen_flow/mobile_screen_flow.slice';
import useDeviceDetect from 'hooks/useDeviceDetect';

import ChatView from './components/ChatView/ChatView';
import ChatList from './components/ChatLists/ChatLists';
import ChatInfo from './components/ChatInfo/ChatInfo';

import './Chat.scoped.scss';

interface Props {
  style?: CSSProperties;
}

const Chat: React.FC<Props> = ({ style }) => {
  const user = useAppSelector(getUser);
  const dispatch = useAppDispatch();

  useEffect(() => {
    socket.connect();
    socket.on('connect', () => undefined);
    socket.on('connect_error', () => {
      socket.io.opts.extraHeaders = {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      };
      socket.disconnect().connect();
    });
    socket.on('message', mess => {
      const newMessage = {
        body: mess.body,
        user_id: mess.user_id,
        user,
        id: mess.id,
        chat_id: mess.chat_id,
        responding: mess.responding ?? null,
        replys: [],
        likes: [],
      };

      dispatch(addMessage(newMessage));
    });
    socket.on('newMessage', payload => {
      // TODO check with borisa can we send a payload for a type of new message
      // direct or group
      dispatch(updateUnreadDirrectMessageCount(payload));
      dispatch(updateUnreadMessageCount(payload));
    });
    socket.on('users', users => {
      const actUsr = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const [, value] of Object.entries(users)) {
        actUsr.push(value);
      }
      dispatch(updateInitialActiveUsers(actUsr));
    });
    socket.on('newUser', userId => {
      const action = {
        type: 'online',
        user_id: userId,
      };
      dispatch(updateUserStatus(action));
    });
    socket.on('userDisconnected', userId => {
      const action = {
        type: 'offline',
        user_id: userId,
      };
      dispatch(updateUserStatus(action));
    });
    return () => {
      dispatch(cleanChatRoom());
      socket.removeAllListeners();
      socket.disconnect();
    };
  }, [dispatch, user]);

  const { isMobile } = useDeviceDetect();
  const currentScreenView = useAppSelector(getCurrentScreenView);

  return (
    <div
      className={`${isMobile ? 'mobile' : ''} ${currentScreenView} chat-container`}
      style={style}
    >
      <div className="chat-list">
        <ChatList />
      </div>
      <div className="chat-view">
        <ChatView />
      </div>

      <div className="chat-info">
        <ChatInfo />
      </div>
    </div>
  );
};

export default Chat;
